<template>
  <div>
    <div v-if="data" :class="{ faded: loading }" style="position: relative">
      <!-- {{ tableData }} -->
      <v-scale-transition>
        <v-progress-circular
          v-if="loading"
          style="
            position: absolute;
            top: 30%;
            left: 50%;
            transform: translate(-50%, -50%);
          "
          size="64"
          width="7"
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-scale-transition>
      <div
        class="d-flex flex-row flex-wrap justify-center justify-sm-start my-2"
        style="width: 100%"
      >
        <div
          v-if="data && data.tearLens"
          class="text-center flex-grow-1"
          style="min-width: 250px; min-height: 230px; margin: -20px"
        >
          <div style="position: relative">
            <div class="skirtClass" v-if="isHybrid"></div>
            <optical-cross-image
              :obj="crossObject"
              :type="mapType"
              class="mx-auto"
              :showHeatmap="mapType == 'NaFl'"
              :customLabels="customCrossLabels"
              meridianFontSize="8"
              :dimensions="isHybrid ? 70 : 100"
              style="position: absolute; top: 0; left: 0"
            >
              <template v-slot:moreStuff><slot></slot></template>
            </optical-cross-image>
          </div>
        </div>
        <div style="min-width: 250px" class="flex-grow-1">
          <v-simple-table dense class="py-2">
            <tbody v-for="item in allFields" :key="item.key">
              <tr v-if="data[item.key]">
                <th style="vertical-align: top">{{ item.label | titleize }}</th>
                <td style="vertical-align: top">
                  <span
                    v-if="item.key == 'potentialVA' && data[item.key]"
                    :style="vaStyle(data[item.key])"
                    >{{ eyeChartVA(data[item.key]) }}
                  </span>
                  <span v-else v-html="formatValue(data[item.key])"></span>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </div>
      </div>
    </div>
    <!-- {{ data }} -->
  </div>
</template>

<script>
// import Name from "../dir/file";
import RxMethods from "@/assets/js/cls/RxMethods";
import StyleUtilities from "@/assets/js/StyleUtilities";

export default {
  name: "ClCalcsResultCard",
  components: {
    // HeatMap: () => import("@/components/calcsStuff/HeatMap"),
    OpticalCrossImage: () => import("@/components/clStuff/OpticalCrossImage"),
  },
  mixins: [RxMethods, StyleUtilities],
  props: {
    calcResults: null,
    lensType: null,
    // isHybrid: null,
    eye: null,
    old: null,
    loading: null,
    calcOptions: null,
  },
  data: function () {
    return {
      headers: [
        {
          text: "Param",
          value: "text",
        },
        { text: "Value", value: "value" },
      ],
      stdFields: [
        { label: "Power", key: "power" },
        { label: "Base Curve", key: "baseCurve" },
        { label: "Diameter", key: "diameter" },
      ],
      finalFields: [
        { label: "Residual Rx", key: "residualRx" },
        { label: "Potential VA", key: "potentialVA" },
      ],
      // don't display the following in the parametric table
      // find a better way to do this ..
      ignoreFields: [
        "isGoodChoiceShort",
        "isGoodChoiceLong",
        "tearLens",
        "lens",
        "score",
        "fullPower",
        "fullBC",
        "group",
        // "hybrid",
      ],
    };
  },
  methods: {
    formatValue(val) {
      // i want to see if val is a string or
      if (typeof val == "string" && val.length > 20)
        val =
          val.replace(
            "(",
            "<div style='font-size:10px; margin: 0 0 10px 10px;'>("
          ) + "</div>";
      return val;
    },
  },
  computed: {
    data: function () {
      return this.calcResults?.[this.eye]?.[this.lensType];
    },
    crossObject: function () {
      let group = this.data?.group;
      if (group == "scls") return this.parseRxString(this.data.fullPower);
      if (this.tearRxObj) return this.tearRxObj;
      return null;
    },
    mapType: function () {
      return this.data?.group == "scls" ? null : "NaFl";
    },

    otherFields: function () {
      let rtn = [];
      if (!this.data) return rtn;
      let stdKeys = this.stdFields.map(function (el) {
        return el.key;
      });
      let finalKeys = this.finalFields.map(function (el) {
        return el.key;
      });
      let fields = Object.keys(this.data);
      fields.forEach((item) => {
        if (
          !stdKeys.includes(item) &&
          !finalKeys.includes(item) &&
          !this.ignoreFields.includes(item)
        ) {
          rtn.push({ label: item, key: item });
        }
      });
      return rtn;
    },
    allFields: function () {
      return [...this.stdFields, ...this.otherFields, ...this.finalFields];
    },
    tableData: function () {
      let rtn = [];
      if (!this.data) return rtn;
      this.allFields.forEach((row) => {
        rtn.push({ text: row.label, value: this.data[row.key] });
      });
      return rtn;
    },
    tearRxObj: function () {
      return this.data?.tearLens
        ? this.parseRxString(this.data.tearLens)
        : null;
    },
    isHybrid: function () {
      return this.calcOptions?.hybrid;
    },
    customCrossLabels: function () {
      let pwrString = this.data?.fullPower;
      // console.log(pwrString);
      let kString = this.data?.fullBC;
      let pwrObj = this.parseRxString(pwrString);
      let kObj = this.parseKstring(kString);
      if (!pwrObj || !kObj) return null;
      let rtn = {};
      let vertPower = this.verticalPower(pwrObj);
      let horizPower = this.horizontalPower(pwrObj);
      rtn.vertPower = this.numToDiopterString(vertPower);
      rtn.horizPower = this.numToDiopterString(horizPower);
      // show the base curve values instead of the meridians
      let vertMeridian = this.prettyKstringDandMM(
        this.verticalKpower(kObj),
        false,
        "D"
      );
      let horizMeridian = this.prettyKstringDandMM(
        this.horizontalKpower(kObj),
        false,
        "D"
      );
      rtn.vertMeridian = vertMeridian.replace("(", "<br>(");
      rtn.horizMeridian = horizMeridian.replace("(", "<br>(");
      return rtn;
    },
  },
};
</script>

<style scoped>
.concern {
  background-color: #fdffab !important;
  padding: 3px 5px !important;
}
.faded {
  opacity: 0.3;
}
.skirtClass {
  border: 1px solid #bae1f6;
  border-radius: 50%;
  height: 110px;
  width: 110px;
  position: absolute;
  top: 21px;
  left: 31px;
  background-image: linear-gradient(359deg, #69a6d047, #e3ffeb52);
  box-shadow: #c3c3c34e 0px 1px 10px 3px;
}
</style>
